module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Iris Gower\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Iris Gower was born in Swansea where she lived all her life. The mother of four adult children, she wrote over twenty bestselling novels, many of which are based around Swansea and the Gower peninsula, from which she took her pseudonym. She received an Honorary Fellowship from the University of Wales Swansea in 1999 and was awarded an MA in Creative Writing from the University of Cardiff.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/RIS6ck/tc-custom/9781788639583.jpg?1704585986966",
      "alt": "This image is the cover for the book Proud Mary"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Proud Mary\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this historical romance, two rival brothers vie for a woman’s affections after her fiancé is jailed for a crime he didn’t commit.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Mary Jenkins had dragged herself up from humble beginnings—first to be overseer in the Canal Street laundry, then to run her own market stall in Sweyn's Eye. But constantly fate—and the Sutton brothers—knocked her down again."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Dean Sutton was prepared to set her up in a shop of her own—but only at his price—while Brandon Sutton threatened to destroy her with a love neither of them could control. But Mary—proud Mary—was a fighter, determined to win whatever the odds, however great the sacrifice.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Canelo Digital Publishing Limited\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0